
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 18 11.03\" id=\"film\" ><title>film</title><g data-name=\"Layer 2\"><path d=\"M13.5 3v4l4.5 3V0l-4.5 3zM10.06 11.03L1 11l-1-1V.97L1 0h11v11l-1.94.03z\"/></g></symbol>";
module.exports = sprite.add(image, "film");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/film.svg
// module id = 654
// module chunks = 1474